module.exports = __webpack_public_path__ + "img/analysis_03_01_m.b5d5016a.png";